import { DialogDisclosure, DialogDismiss, FormSubmit } from "@ariakit/react";
import { classNames } from "@indietabletop/appkit/class-names";
import { ExternalLink } from "@indietabletop/appkit/external-link";
import { useRevertingState } from "@indietabletop/appkit/use-reverting-state";
import { ReactNode } from "react";
import * as css from "./style.css";

function CopyToClipboardButton(props: { value: string | null; label: string }) {
  const [copiedTimestamp, setCopiedTimestamp] = useRevertingState<
    number | null
  >(null, 1500);

  return (
    <button
      type="button"
      disabled={!props.value}
      className={css.dialogButton}
      onClick={() => {
        if (props.value) {
          void navigator.clipboard.writeText(props.value).then(() => {
            setCopiedTimestamp(Date.now());
          });
        }
      }}
    >
      {copiedTimestamp ? "Copied!" : props.label}
    </button>
  );
}

function WebShareButton(props: {
  shareData: { title: string; url: string } | null;
  label: string;
}) {
  const [copiedTimestamp, setCopiedTimestamp] = useRevertingState<
    number | null
  >(null, 1500);

  return (
    <button
      type="button"
      disabled={!props.shareData}
      className={css.dialogButton}
      onClick={() => {
        if (props.shareData) {
          void navigator.share(props.shareData).then(
            () => {
              setCopiedTimestamp(Date.now());
            },
            () => {
              console.info("Not shared");
            },
          );
        }
      }}
    >
      {copiedTimestamp ? "Shared!" : props.label}
    </button>
  );
}

export function ShareButton(props: {
  shareData: { title: string; url: string } | null;
}) {
  const shareIsSupported = "share" in navigator;

  if (shareIsSupported) {
    return <WebShareButton shareData={props.shareData} label="Share link" />;
  }

  return (
    <CopyToClipboardButton
      value={props.shareData?.url ?? null}
      label="Copy share link"
    />
  );
}

export function DialogDismissButton(props: { children: string }) {
  return (
    <DialogDismiss className={css.dialogButton}>{props.children}</DialogDismiss>
  );
}

export function DialogSubmitButton(props: { children: string }) {
  return <FormSubmit className={css.dialogButton}>{props.children}</FormSubmit>;
}

export function DialogDisclosureButton(props: { children: string }) {
  return (
    <DialogDisclosure className={css.dialogButton}>
      {props.children}
    </DialogDisclosure>
  );
}

export function LinkButton(props: {
  children: ReactNode;
  href: string;
  className?: string;
  sticky?: boolean;
  textAlign?: "center";
}) {
  const { sticky, textAlign, className, ...linkProps } = props;

  return (
    <ExternalLink
      {...linkProps}
      className={classNames(css.btn({ sticky, textAlign }), className)}
    />
  );
}
